module.exports = __webpack_public_path__ + "static/media/arsyad-2.74043ba4.jpg";